module.exports = __webpack_public_path__ + "static/media/header-jumbo.583dd0ec.jpeg";